/**
 * MiniUnitCard — Step 3 (only when the parent unit is subdivided).
 * Renders inside the parent-unit context so the teacher can see they
 * are zooming in.
 */
import React from "react";

const MiniUnitCard = ({ unit, mini, selected, onSelect }) => (
  <button
    type="button"
    onClick={() => onSelect(mini)}
    data-testid={`math-engine-mini-${mini.label}`}
    className={`rounded-xl border-2 p-5 text-left transition-all ${
      selected
        ? "border-[#96ded1] bg-[#96ded1]/10 shadow-sm"
        : "border-[#4a6984]/15 bg-white hover:border-[#4a6984]/30 hover:shadow-sm"
    }`}
  >
    <div className="flex items-start justify-between gap-2 mb-2">
      <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#4a6984]/70">
        {mini.label}
      </p>
      <span className="text-[10px] font-bold text-[#4a6984]/60">
        {mini.specific_expectations.length} expectations
      </span>
    </div>
    <p className="font-extrabold text-base text-[#1c2d3d] tracking-tight leading-tight">
      {mini.name}
    </p>
    <p className="mt-2 text-[11px] text-[#4a6984]/70 leading-snug">
      Inside <span className="font-bold">Unit {unit.unit_number} — {unit.name}</span>
      {" · "}Day budget inherited from parent unit ({unit.day_budget})
    </p>
    <div className="mt-3 flex flex-wrap gap-1.5">
      {mini.specific_expectations.slice(0, 8).map((c) => (
        <span
          key={c}
          className="inline-flex items-center rounded-full bg-[#96ded1]/20 text-[#1c2d3d] px-2 py-0.5 text-[10px] font-bold tracking-tight"
        >
          {c}
        </span>
      ))}
    </div>
  </button>
);

export default MiniUnitCard;
